
import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './Routes/Routes';
import { useEffect, useState } from 'react';
import 'aos/dist/aos.css';
import Aos from 'aos';
import Loader from './component/Spinner/Loader';

function App() {
  const [loading, setLoading] = useState(true); 
  if (loading) {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }

  useEffect(()=>{
    Aos.init({duration:3000})
  },[])
  return loading ? (
    <Loader></Loader>
  ):
    (
    
    
      <div className="App ">
       <RouterProvider router={router}></RouterProvider>
      </div>
    );
  
}

export default App;
